import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {
  user: any;

  constructor(private router: Router) {}

  selectRole(idRol: number): void {
    this.router.navigate(['/login'], { queryParams: { id_rol: idRol } });
  }
}
